import { useQuery } from "@tanstack/react-query";

import { getForeignWorkersByLocation } from "../../services/foreign_workers";

import { EtyForeignWorker } from "../../interfaces/entities";

const useGetForeignWorkersByLocation = (locationId: number) => {
    const queryFn = async (): Promise<EtyForeignWorker[]> => {
        return await getForeignWorkersByLocation(locationId);
    };

    return useQuery({
        queryKey: ['workers_for_location', locationId],
        queryFn,
        enabled: locationId > 0,
        retry: 0,
    });
};

export default useGetForeignWorkersByLocation;